import { plainText, url } from '../../../../../../../modules/validators';
import { trimSpaces, trimSpacesLeft } from '../../../../../../../modules/formatters';
import { FormVmItemConfigType } from '../../../../../../../infrastructure/form-viewmodel-controller';
import { ConnectionType } from '../../../../../../../api/connections.dao';
import { FormInputType } from '../../../../../../_events/_manage-event/shared/connections-list/_connection-form/connection-form.viewmodel';
import { buildConfigList } from '../../../../../../../infrastructure/utils/form-config.utils';

export enum FieldKey {
    TYPE = 'type',
    NAME = 'name',
    MEETING_UNIQUE_REFERENCE = 'meetingUniqueReference',
    CONNECTION_LINK = 'connectionLink',
    ALTERNATIVE_LINK = 'alternativeLink',
    HOST_LINK = 'hostLink',
    CUSTOM_CONNECTION_ID = 'customConnectionId',
    CONNECTION_PASSWORD = 'connectionPassword',
    CONNECTION_ACCOUNT = 'connectionAccount',
    SIP = 'sip',
    CONNECTION_HOST_KEY = 'connectionHostKey',
    DIAL_FOR_VS = 'dialForVs',
    CONNECTION_TOPIC = 'connectionTopic',
    MEETING_INVITATION = 'meetingInvitation',
    CONNECTION_NOTES = 'connectionNotes',
}

export const FORM_CONFIG = {
    [FieldKey.TYPE]: {
        labelDescriptor: { id: 'oe.templates.connection.type', defaultMessage: 'Connection Type', description: 'Label text' },
        defaultValue: ConnectionType.Other,
        readOnly: true
    },
    [FieldKey.NAME]: {
        labelDescriptor: { id: 'oe.templates.connection.name', defaultMessage: 'Name', description: 'Label text' },
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft],
    },
    [FieldKey.CONNECTION_LINK]: {
        labelDescriptor: { id: 'oe.templates.connection.connectionLink', defaultMessage: 'Connection Link', description: 'Label text' },
        validators: [plainText.maxLength.medium, url.regExp],
        formatters: [trimSpaces],
    },
    [FieldKey.ALTERNATIVE_LINK]: {
        labelDescriptor: { id: 'oe.templates.connection.alternativeLink', defaultMessage: 'Alternative Link', description: 'Label text' },
        validators: [plainText.maxLength.medium, url.regExp],
        formatters: [trimSpaces],
    },
    [FieldKey.HOST_LINK]: {
        labelDescriptor: { id: 'oe.templates.connection.hostLink', defaultMessage: 'Host Link', description: 'Label text' },
        validators: [plainText.maxLength.medium, url.regExp],
        formatters: [trimSpaces],
    },
    [FieldKey.CUSTOM_CONNECTION_ID]: {
        labelDescriptor: { id: 'oe.templates.connection.connectionId', defaultMessage: 'Connection ID', description: 'Label text' },
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft],
    },
    [FieldKey.CONNECTION_PASSWORD]: {
        labelDescriptor: { id: 'oe.templates.connection.connectionPassword', defaultMessage: 'Connection Password', description: 'Label text' },
        validators: [plainText.maxLength.short],
        formatters: [trimSpaces],
    },
    [FieldKey.CONNECTION_ACCOUNT]: {
        labelDescriptor: { id: 'oe.templates.connection.connectionAccount', defaultMessage: 'Connection Account', description: 'Label text' },
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft],
    },
    [FieldKey.SIP]: {
        labelDescriptor: { id: 'oe.templates.connection.sip', defaultMessage: 'SIP', description: 'Label text' },
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft],
    },
    [FieldKey.CONNECTION_HOST_KEY]: {
        labelDescriptor: { id: 'oe.templates.connection.connectionHostKey', defaultMessage: 'Connection Host Key', description: 'Label text' },
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft],
    },
    [FieldKey.DIAL_FOR_VS]: {
        labelDescriptor: { id: 'oe.templates.connection.dialForVS', defaultMessage: 'Dial for VS', description: 'Label text' },
        valueOptions: [null, 'In', 'Out'],
        fieldTypeHTML: FormInputType.Select
    },
    [FieldKey.CONNECTION_TOPIC]: {
        labelDescriptor: { id: 'oe.templates.connection.connectionTopic', defaultMessage: 'Connection Topic', description: 'Label text' },
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft],
    },
    [FieldKey.MEETING_INVITATION]: {
        labelDescriptor: { id: 'oe.templates.connection.meetingInvitation', defaultMessage: 'Meeting Invitation', description: 'Label text' },
        validators: [plainText.maxLength.long],
        formatters: [trimSpacesLeft],
        fieldTypeHTML: FormInputType.Textarea
    },
    [FieldKey.CONNECTION_NOTES]: {
        labelDescriptor: { id: 'oe.templates.connection.connectionNotes', defaultMessage: 'Connection Notes', description: 'Label text' },
        validators: [plainText.maxLength.long],
        formatters: [trimSpacesLeft],
        fieldTypeHTML: FormInputType.Textarea
    },
    [FieldKey.MEETING_UNIQUE_REFERENCE]: {
        label: 'Unique Reference',
        labelDescriptor: { id: 'oe.connection.uniqueReference', defaultMessage: 'Unique Reference', description: 'Label text' },
        valueOptions: [ { label: 'No Unique Reference', value: 0 }, 1, 2, 3, 4, 5 ],
        fieldTypeHTML: FormInputType.Select
    }
};

export const configList: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);
